module.exports = __webpack_public_path__ + "img/GAME_CROSSTURTLE2.e57e8c21.jpg";